import { BaseGridDropListComponent } from '@anecdotes/design-system/drag-drop';
import { IS_MOBILE_TOKEN } from '@anecdotes/design-system/injection-tokens';
import { LoaderManagerService } from '@anecdotes/design-system/loaders';
import { DocumentResponse, DownloadingResource, OrderResourceType, TrustCenterEventService, TrustCenterFacadeService, TrustResourceEventDataProperty } from '@anecdotes/shared-trust-center';
import { moveItemInArray } from '@angular/cdk/drag-drop';
import { ChangeDetectionStrategy, Component, DestroyRef, Inject, OnDestroy, OnInit, SkipSelf } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Observable, firstValueFrom, shareReplay } from 'rxjs';
import { TrustCenterModalService } from '../../../../services/trustcenter-modals/trustcenter-modals.service';

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentsComponent extends BaseGridDropListComponent implements OnInit, OnDestroy {
  protected readonly DownloadingResource = DownloadingResource;

  editing$: Observable<boolean>;

  isPreviewMode$: Observable<boolean>;
  documents: DocumentResponse[];

  constructor(
    @SkipSelf() private loaderManager: LoaderManagerService,
    private trustCenterFacadeService: TrustCenterFacadeService,
    private trustCenterModalService: TrustCenterModalService,
    private destroyRef: DestroyRef,
    private readonly trustCenterEventService: TrustCenterEventService,
    @Inject(IS_MOBILE_TOKEN) readonly isMobile: boolean,
  ) {
    super();
  }

  ngOnInit(): void {
    this.editing$ = this.trustCenterFacadeService.isEditing();
    this.isPreviewMode$ = this.trustCenterFacadeService.isPreviewMode().pipe(shareReplay({ bufferSize: 1, refCount: true }));

    this.trustCenterFacadeService
      .getDocuments()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((documents) => {
        this.documents = documents;
        this.cd.detectChanges();
      });
  }

  buildTranslationKey(key: string): string {
    return `trustCenter.${key}`;
  }

  requestAccess(): void {
    this.trustCenterModalService.openRequestAccessModal();
  }

  ngOnDestroy(): void {
    this.loaderManager.hide();
  }

  updateOrder(sourceIndex: number, targetIndex: number): void {
    moveItemInArray(this.documents, sourceIndex - 1, targetIndex - 1);
    
    const orderList = this.documents.map((document) => document.id);
    this.trustCenterFacadeService.reorderResources(OrderResourceType.Document, orderList);
  }

  openAddDocumentSidePanel(): void {
    this.trustCenterModalService.openAddDocumentSidePanel();
  }

  async onDocumentClick(document: DocumentResponse): Promise<void> {
    const editing = await firstValueFrom(this.editing$);
    const isPreviewMode = await firstValueFrom(this.isPreviewMode$);

    if (editing) {
      this.trustCenterModalService.openDocumentEditSidePanel(document.id);
    } else {
      if (!isPreviewMode) {
        const companyName = await firstValueFrom(this.trustCenterFacadeService.getName());

        this.trustCenterEventService.trackClickOnResourceItem(TrustResourceEventDataProperty.Documents, document.id, companyName);
      }

      this.trustCenterModalService.openDocumentSidePanel(document.id);
    }
  }
}
